import { safeStorage } from "./storage";

// Which onboarding a person is in. Ads for the new mobile setup send people to
// /start; everyone else keeps the original /setup wizard. Visiting /start marks
// the browser, and the shared guards (StoreCheckWrapper, useSetupStatus, the
// /setup route) read the mark so a /start user is never dropped into /setup:
// not after signing in again, not from /dashboard, and not when Stripe sends
// them back to /setup?payment=success. With no mark everything behaves exactly
// as before.

export const ONBOARDING_FLOW_KEY = "onboardingFlow";
export const START_FLOW = "start";

export function markStartFlow() {
  safeStorage.set(ONBOARDING_FLOW_KEY, START_FLOW);
}

export function clearStartFlow() {
  safeStorage.remove(ONBOARDING_FLOW_KEY);
}

export function isStartFlow() {
  return safeStorage.get(ONBOARDING_FLOW_KEY) === START_FLOW;
}

export function getOnboardingPath() {
  return isStartFlow() ? "/start" : "/setup";
}

export function isOnboardingPath(pathname = "") {
  return pathname.includes("/setup") || pathname.startsWith("/start");
}
